import { render, staticRenderFns } from "./RegistrationNoCorrection.vue?vue&type=template&id=232cb52f&scoped=true"
import script from "./RegistrationNoCorrection.vue?vue&type=script&lang=js"
export * from "./RegistrationNoCorrection.vue?vue&type=script&lang=js"
import style0 from "./RegistrationNoCorrection.vue?vue&type=style&index=0&id=232cb52f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232cb52f",
  null
  
)

export default component.exports